// Trend keyword types
export const TREND_KEYWORD_TYPES = {
  COMPANY_RELATED: 1,
  UNRELATED: 2,
}

/**
 * Create trend filter items
 * @param {Function} t - Translation function
 * @returns {Array} - Array of filter items
 */
export const getTrendFilterItems = (t) => [
  { id: '', name: t('socialMedia.components.createPost.trends.filter.all') },
  {
    id: TREND_KEYWORD_TYPES.COMPANY_RELATED.toString(),
    name: t('socialMedia.components.createPost.trends.filter.related'),
  },
]
